import { Injectable } from '@angular/core';
import { MainLayout1Component } from '../components/main-layout1/main-layout1.component';
import { MainLayout2Component } from '../components/main-layout2/main-layout2.component';
import { ComponentProviderService } from '../../core/services/component-provider.service';

@Injectable({
  providedIn: 'root'
})
export class MainLayoutProviderService extends ComponentProviderService {

  constructor() {
    super(MainLayout1Component);
    this.collection = {
      MainLayout1Component,
      MainLayout2Component
    };
  }
}
